import { parse } from 'date-fns'

export function isTimeStringValid(timeStr: string): boolean {
  if (!timeStr) {
    return false
  }

  const date = parse(timeStr, 'HH:mm', new Date())

  return !isNaN(Number(date))
}
